import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./App";

export default function IntroScreen() {
  const { hasStarted, hasLoaded, setHasStarted } = useContext(AppContext);
  const [screenState, setScreenState] = useState(0);

  function tryToStart() {
    if (hasLoaded && !hasStarted) {
      setHasStarted(true);
    }
  }

  function nextScreen() {
    setScreenState(1);
    setTimeout(() => {
      setScreenState(2);
    }, 700);
  }

  useEffect(() => {
    return () => {};
  }, [hasLoaded, hasStarted]);
  return (
    <div
      className={`w-screen h-screen select-none  p-4 flex justify-center items-center z-20 fixed top-0 left-0 text-white transition-opacity duration-1000 bg-zinc-900 ${
        hasStarted
          ? "pointer-events-none opacity-0"
          : "pointer-events-auto, opacity-100"
      }`}
    >
      {screenState === 2 ? (
        <div
          className={`font-cardo text-lg sm:text-2xl max-w-lg leading-relaxed transition-opacity fadeIn`}
        >
          <b className="text-2xl sm:text-3xl">
            Use the arrow keys or touch the screen to move.
          </b>
          <i className="my-8 mx-auto block">
            This experiment is all about music - headphones are highly
            recommended. If you experience any problems, try changing the
            graphics settings by clicking on the wheel in the right top of the
            screen
          </i>
          <h1
            onClick={tryToStart}
            className="hover:underline cursor-pointer inline-block text-3xl"
          >
            START
          </h1>
        </div>
      ) : (
        <div
          className={`font-cardo text-lg sm:text-2xl max-w-lg leading-relaxed transition-opacity ${
            screenState === 1 ? "opacity-0" : "opacity-1"
          }`}
        >
          <h1 className="text-5xl sm:text-6xl mb-8">
            <i>Welcome to Manifold</i>
          </h1>
          <p>
            <i>Manifold</i> is an interactive musical composition, built from 10
            different parts. You can listen to these parts by moving close to
            them.
          </p>
          <i className="my-12  block">
            Explore the music or just drift around freely...
          </i>
          {hasLoaded ? (
            <>
              <h1
                onClick={nextScreen}
                className="hover:underline cursor-pointer inline-block text-3xl"
              >
                Continue
              </h1>
            </>
          ) : (
            <>
              <h1 className=" inline-block text-3xl">Loading...</h1>
            </>
          )}
        </div>
      )}
    </div>
  );
}
